// app/js/services/Service.js
var Service = angular.module('Service', ['ngStorage', 'ngSanitize']);

Service.controller('Service', function(){
    
    
});